export const VITE_CERLUCENT_API = import.meta.env.VITE_CERLUCENT_API;
export const VITE_STRIPE_PUB_KEY = import.meta.env.VITE_STRIPE_PUB_KEY;
export const VITE_SK_STIPE_KEY = import.meta.env.VITE_SK_STIPE_KEY;
export const VITE_GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;
